import { oz } from '@weft/utils';
import { ObjectIdSchema } from '../../primitives/object-id-schema';
import { withNullAsOptional } from '../../utils/literal-transforms';
import { PricingSchema } from '../pricing/pricing-schema';
import { ProductSettingsSchema } from './fixed-product-variants/product-settings-schemas';

export const NewProductVariantSchema = oz.object({
  meterId: withNullAsOptional(ObjectIdSchema),
  pricing: PricingSchema,
  settings: withNullAsOptional(ProductSettingsSchema),
  description: withNullAsOptional(oz.string().nonempty()),
  name: oz.string().nonempty('Product variant name is required'),
}).openapi('NewProductVariant');

export type NewProductVariant = oz.infer<typeof NewProductVariantSchema>;